<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2024-01-02 11:38:44
!-->
<template>
  <div id="account-details" class="account-details" :model="dataForm">
    <div class="account-name">
      <div>{{ dataForm.realName.substring(0,1) }}</div>
      <p>{{ dataForm.realName }}</p>
    </div>
    <div class="basic-data one">
      <div class="basic-left">
        <div class="basic-info">
          <div class="basic-title">Name</div>
          <div class="basic-content">{{ dataForm.realName }}</div>
        </div>
        <div class="basic-info">
          <div class="basic-title">Company name</div>
          <div class="basic-content">{{ dataForm.customerName }}</div>
        </div>
        <div class="basic-info">
          <div class="basic-title">Phone Number</div>
          <div v-if="dataForm.mobilePhone!=null" class="basic-content">{{ dataForm.mobilePhone }}</div>
        </div>
      </div>
      <div class="basic-right">
        <button class="by-common--primary" @click="()=>{isDetailEdit = true}">Edit</button>
      </div>
    </div>
    <div class="basic-data two">
      <div class="basic-left">
        <div class="basic-info">
          <div class="basic-title">Email</div>
          <div class="basic-content">{{ dataForm.email }}</div>
        </div>
      </div>
      <div class="basic-right">
        <button class="by-common--primary" @click="()=>{isChangeEmail = true}">Edit</button>
      </div>
    </div>
    <div class="basic-data two">
      <div class="basic-left">
        <div class="basic-info">
          <div class="basic-title">Password</div>
          <div class="basic-content">******</div>
        </div>
      </div>
      <div class="basic-right">
        <button class="by-common--primary" @click="()=>{isChangePassword = true}">Edit</button>
      </div>
    </div>
    <DetailEdit v-if="isDetailEdit" ref="DetailEdit" :is-show="isDetailEdit" @close="()=>{isDetailEdit = false}" @refresh="refresh" />
    <ChangeEmail v-if="isChangeEmail" ref="ChangeEmail" :is-show="isChangeEmail" @close="()=>{isChangeEmail = false}" @refresh="refresh" />
    <ChangePassword v-if="isChangePassword" ref="ChangePassword" :is-show="isChangePassword" @close="()=>{isChangePassword = false}" @refresh="refresh" />
  </div>
</template>

<script>
import DetailEdit from './detailEdit.vue'
import ChangeEmail from './changeEmail.vue'
import ChangePassword from './changePassword.vue'
import request from '@/utils/request'
import { getCookie } from '@/utils/cookiejs'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    DetailEdit, ChangeEmail, ChangePassword
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      dataForm: {
        realName: '',
        customerName: '',
        mobilePhone: '',
        email: ''
      },
      isDetailEdit: false,
      isChangeEmail: false,
      isChangePassword: false,
      token: ''
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    if (this.token) {
      this.getCustomerInfo()
    }
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    getCustomerInfo() {
      request({
        url: `/api/crm/Customer/GetCurrCustomer`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then(res => {
        if (res.data != null) {
          this.dataForm.realName = res.data.firstName + ' ' + res.data.lastName
          this.dataForm.email = res.data.email
          this.dataForm.customerName = res.data.customerName
          this.dataForm.mobilePhone = res.data.mobilePhone
        }
      })
    },
    refresh(isrRefresh) {
      // this.isEditDialog = false
      if (isrRefresh) this.getCustomerInfo()
    }
  }
}
</script>
<style scoped lang='scss'>
.account-details{
    .account-name{
        width: 100%;
        height: 154px;
        background: #FFFFFF;
        border-radius: 8px;
        text-align: center;
        padding-top: 30px;
        div{
            width: 88px;
            height: 88px;
            background: #ED7738;
            border-radius: 55px;
            border: 3px solid rgba(233,85,6,0);
            font-size: 50px;
            font-family: D-DINExp, D-DINExp;
            font-weight: bold;
            color: #FFFFFF;
            margin: 0 auto;
            line-height: 88px;
        }
        p{
            font-size: 18px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            color: #333333;
            margin-top: 19px;
        }
    }
    .one{
        height: 136px;
    }
    .two{
        height: 40px;
    }
    .basic-data{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        background: #FFFFFF;
        border-radius: 8px;
        margin: 16px 0;
        padding: 16px 0;
        .basic-left{
            .basic-info{
                display: flex;
                .basic-title{
                    margin-left: 24px;
                    text-align: left;
                    width: 154px;
                    height: 44px;
                    font-size: 14px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    line-height: 40px;
                }
                .basic-content{
                    height: 44px;
                    line-height: 40px;
                    font-size: 14px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    margin-left: 24px;
                }
            }
        }
        .basic-right{
            //flex: 1;
            margin-right: 24px;
            button{
                width: 72px;
                height: 32px;
            }

        }
    }
}
</style>
